var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.76588,
    height: 500,
    viewBox: "0 0 47.563051 132.29167",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-164.70832)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE4E5",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "221.223526px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 49.83996582
    },
    id: "text3874"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13.494635,237.26964 c 2.875906,3.53958 5.309365,7.07915 7.742823,10.61873 0.221224,0.88489 1.106118,2.21223 1.106118,2.65468 0,0 0,0.44245 -0.221223,0.66367 -0.442447,0.66367 -1.106118,0.8849 -1.991012,0.8849 -0.663671,0 -2.212235,-0.44245 -2.875906,-0.66367 -0.884894,0 -1.991012,-0.44245 -2.875906,-0.44245 C 6.8579293,250.9855 0,258.5071 0,268.01971 c 0,8.84894 7.5215999,17.47666 20.573788,27.43172 1.327341,1.10612 3.097129,1.54856 4.42447,1.54856 1.327342,0 2.654683,-0.44244 2.654683,-1.10612 0.221223,-0.44244 0.442447,-0.88489 0.442447,-1.10611 0,-1.76979 -1.327341,-3.09713 -2.875906,-4.42447 -2.212235,0 -4.203247,-4.6457 -4.645694,-6.19426 -0.442447,-1.54857 -0.663671,-3.09713 -0.663671,-4.6457 0,-5.53058 2.654683,-11.72484 8.406494,-12.83096 0.884894,-0.22122 1.769789,-0.22122 2.875906,-0.22122 5.088141,0 10.839953,1.99101 13.715859,3.09713 0.221223,0 0.442447,0.22122 0.442447,0.22122 0.66367,0.22122 0.884894,0.22122 1.327341,0.22122 0.442447,0 0.884894,-0.22122 0.884894,-0.88489 0,-1.99101 -4.645694,-7.96405 -6.636706,-9.95506 -6.636705,-8.18527 -12.167294,-14.82198 -12.167294,-24.55581 0,-0.8849 0.221224,-1.76979 0.221224,-2.43346 0.66367,-10.17628 7.079153,-18.804 11.724847,-25.88315 0.442447,-0.8849 0.66367,-1.76979 0.66367,-2.65469 0,-1.76978 -0.66367,-3.53957 -0.66367,-3.53957 0,0 -26.3256,-30.9713 -29.201506,-34.06843 -0.884894,-0.88489 -2.2122349,-1.32734 -3.3183525,-1.32734 -1.7697883,0 -3.5395765,1.10612 -3.5395765,3.53958 0,0.88489 0.2212236,1.76979 0.8848941,2.87591 0.6636706,1.99101 10.6187289,11.06117 10.6187289,23.67091 0,6.63671 -2.654682,14.15831 -10.6187289,22.5648 -1.7697882,1.76979 -2.4334587,3.7608 -2.4334587,5.08814 0,2.43346 1.7697882,4.20325 1.7697882,4.20325 z",
    style: {
      strokeWidth: 49.83996582
    },
    id: "path3876"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.fd12ce11d0cdffbb39505cc5ac5ca63f.svg";
export { ForwardRef as ReactComponent };